import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { Title } from "@angular/platform-browser";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

import * as L from 'leaflet';
import { icon, Marker } from 'leaflet';
import { OpenStreetMapProvider, SearchControl } from 'leaflet-geosearch';

import { MatSelectionListChange } from "@angular/material/list";
import { MatDialog } from "@angular/material/dialog";
import { MatTabChangeEvent } from "@angular/material/tabs";

import { TranslateService } from "@ngx-translate/core";
import { cloneDeep } from "lodash";

import { BehaviorSubject, EMPTY, Observable, Subscription, zip } from "rxjs";
import { catchError, finalize, map, shareReplay, skip, take, tap } from "rxjs/operators";
import { Store, select } from "@ngrx/store";
import {
  createSite,
  getCategoriesForListByUsage,
  getPropertiesForListByUsage,
  getSite,
  getSiteProfileList,
  getSiteRegionsList,
  resetSite,
  updateSite,
} from "src/app/store/actions/sites/sites.actions";
import {
  AppState,
  loadedCategoriesListSiteState,
  loadedPropertiesListSiteState,
  siteLoadedState,
  siteProfileLoadedState,
  siteRegionLoadedState,
  sitesStateIsLoading,
  sitesStateCreated,
  loadedTenantConfigState,
} from "src/app/store/reducers";

import { SnackbarService } from "src/app/shared/services/snackbar/snackbar.service";
import { TenantService } from "src/app/shared/services/tenant/tenant.service";
import { EntityService } from "src/app/shared/services/entity/entity.service";
import { SiteGroupsService } from "src/app/shared/services/site-groups/site-groups.service";

import { PosDeviceDTO } from "src/app/models/site-devices/posDTO";
import { SiteDTO } from "src/app/models/Sites/siteDTO";
import { CategoryDTO } from "src/app/models/Categories/categoryDTO";
import { PropertyDTO } from "src/app/models/Properties/propertyDTO";
import { SnackbarType } from "src/app/models/snackbar/snackbar.model";
import { TopCard } from "src/app/models/top-card/top-card.model";
import {
  Dialog,
  GuardConfirmationDialogData,
} from "src/app/models/dialog/dialog.model";
import { TenantDTO } from "src/app/models/Tenant/Tenant.model";
import { EntityDTO } from "src/app/models/entity/entity.model";
import { SiteGroupDTO } from "src/app/models/Sites/siteGroupDTO";

import { FormUtils } from "src/app/shared/utils/formUtils";
import { CategoriesAndPropsUtils } from "../../../shared/utils/categoriesAndPropsUtils";
import { isAuthenticated } from "src/app/shared/utils/authenticationUtils";
import { FieldType, FilterName } from "src/app/models/custom-table/custom-table.model";
import { AutocompleteSelectItem } from "src/app/models/selection-list/autocomplete-select-item.model";
import { setSnackbar } from "src/app/store/actions/messages/message.actions";
import { UserProfileCodes } from "src/app/models/UserDetails/userProfileDTO";
import { SnackBarUtils } from "src/app/shared/utils/snackbarUtils";

import { ConfirmationDialogComponent } from "src/app/shared/modules/dialogs/confirmation-dialog/confirmation-dialog.component";
import { CanComponentDeactivate } from "src/app/shared";
import { SitesService } from "src/app/shared/services/sites/sites.service";


//Site Detail Form
export const FORM_PARAMS = {
  code: "code",
  siteNumber: "siteNumber",
  description: "description",
  profile: "profile",
  tenant: "tenant",
  entity: "entity",
  region: "region",
  siteGroup: "siteGroup",
  latitude: "latitude",
  longitude: "longitude",
  enabled: "enabled",
  ledSite: "ledSite",
  vatin: "vatin",
  categories: "categories",
  properties: "properties",
  comment: "comment",
  street: "street",
  postalZipCode: "postalZipCode",
  city: "city",
  phone: "phone",
};

const USAGE_CODE = "SITE";

const DEFAULT_LAT = 44.00;
const DEFAULT_LNG = -4.00;

const AddSiteLedSiteConfirmationDialogData = {
  data: {
    message: "SiteManagement.addLedSiteConfirmationMessage",
    message2: "SiteManagement.confirmChange",
    buttonText: {
      ok: "TableTemplate.ConfirmationDialog.AcceptButton",
      cancel: "TableTemplate.ConfirmationDialog.CancelButton",
    },
  },
};

const RemoveSiteLedSiteConfirmationDialogData2 = {
  data: {
    message: "SiteManagement.removeLedSiteConfirmationMessage",
    message2: "SiteManagement.confirmChange",
    buttonText: {
      ok: "TableTemplate.ConfirmationDialog.AcceptButton",
      cancel: "TableTemplate.ConfirmationDialog.CancelButton",
    },
  },
};

@Component({
  selector: "app-sites-details",
  templateUrl: "./sites-details.component.html",
  styleUrls: ["./sites-details.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class SitesDetailsComponent
  implements OnInit, AfterViewInit, AfterViewChecked, OnDestroy, CanComponentDeactivate
{
  showTopcardUpdate = true;

  siteFccDevicesTabs = [
    {
      description: "SiteManagement.FuelProducts",
      icon: "oil_barrel",
      selected: true,
    },
    {
      description: "SiteManagement.Grades",
      icon: "rule",
      selected: false,
    },
    {
      description: "SiteManagement.Probes",
      icon: "device_thermostat",
      selected: false,
    },
    {
      description: "SiteManagement.PriceSigns",
      icon: "price_change",
      selected: false,
    },
    {
      description: "SiteManagement.FuelPoints",
      icon: "local_gas_station",
      selected: false,
    },
    {
      description: "SiteManagement.Dispensers",
      icon: "roofing",
      selected: false,
    },
    {
      description: "SiteManagement.Fccs",
      icon: "settings_input_composite",
      selected: false,
    },
  ];

  sitePosDevicesTabs = [
    {
      description: "SiteManagement.Poss",
      icon: "point_of_sale",
      selected: true,
    },
    {
      description: "SiteManagement.Peripherals",
      icon: "usb",
      selected: false,
    },
  ];

  siteStoreDevicesTabs = [
    {
      description: "SiteManagement.StoreProducts",
      icon: "shopping_cart",
      selected: true,
    },
  ];

  warehousesTabs = [
    {
      description: "SiteManagement.WetWarehouses",
      icon: "water_damage",
      selected: true,
    },
    {
      description: "SiteManagement.DryWarehouses",
      icon: "inventory_2",
      selected: false,
    },
  ];

  //Site
  isLoading$: Observable<boolean>;
  loadedSite$: Observable<SiteDTO>;
  created$: Observable<boolean>;

  //top-card configuration
  card: TopCard;
  icon = "add";

  //Profiles
  profileList$: Observable<any[]>;
  profileList: any;

  //Region
  regionList$: Observable<any[]>;
  regionList: any;

  //Subscriptions
  loadedSiteSubs: Subscription;
  createdSub: Subscription;
  multiSubs: Subscription;

  //POS List
  posDeviceList$: Observable<PosDeviceDTO[]>;
  posDeviceList: any;
  posDevices: any[];

  //Category List
  categoryList$: Observable<CategoryDTO[]>;
  categoryList: CategoryDTO[];

  //Property List
  propertyList$: Observable<PropertyDTO[]>;
  propertyList: PropertyDTO[];

  isNotFuelFilter = {
    column: "isFuel",
    fieldType: FieldType.BOOLEAN,
    operator: FilterName.EQUAL,
    value: false
  };

  //Navigation
  currCode: string;

  currentSite: SiteDTO;

  //Tenants
  isLoadingTenant$ = new BehaviorSubject<boolean>(false);
  tenantsList$: Observable<TenantDTO[]>;
  tenantsList: AutocompleteSelectItem[] = [];
  searchTimer: number;

  currentTenant$: Observable<any>;
  currentUserProfile = localStorage.getItem("profileCode");

  //Entities
  isLoadingEntity$ = new BehaviorSubject<boolean>(false);
  entitiesList$: Observable<EntityDTO[]>;
  entitiesList: AutocompleteSelectItem[] = [];
  searchTimer2: number;

  isLoadingTenantEntity$ = new BehaviorSubject<boolean>(false);

  //Site Group
  isLoadingSiteGroup$ = new BehaviorSubject<boolean>(false);
  siteGroupsList$: Observable<SiteGroupDTO[]>;
  siteGroupsList: AutocompleteSelectItem[] = [];
  searchTimer3: number;

  //Actions
  creation: boolean = false;
  duplication: boolean = false;

  isWarehouseSelected: boolean = false;

  //Form
  siteDataForm: FormGroup;

  //Language
  langSubscription: Subscription;

  //States
  isWarehousePristine: boolean = true;
  isDispenserPristine: boolean = true;
  isFccPristine: boolean = true;
  isPosPristine: boolean = true;
  isFuelPointPristine: boolean = true;
  isPriceSignPristine: boolean = true;
  isTankGaugePristine: boolean = true;
  isProductsPristine: boolean = true;
  isGradesPristine: boolean = true;
  isPeripheralPristine: boolean = true;
  isMultimediaPristine: boolean = true;

  //Leaflet Map
  map: any;
  marker: any;
  emitEvent = true;

  ledSiteSubscription: Subscription;

  changesTimer: number;
  streetSubscription: Subscription;
  postalZipCodeSubscription: Subscription;
  citySubscription: Subscription;

  constructor(
    private translate: TranslateService,
    private fb: FormBuilder,
    private titleService: Title,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private store: Store<AppState>,
    private snackbarService: SnackbarService,
    private tenantService: TenantService,
    private entityService: EntityService,
    private siteGroupsService: SiteGroupsService,
    private sitesService: SitesService,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog
  ) {
    this.titleService.setTitle(
      this.translate.instant("SiteManagement.Details")
    );

    this.isLoading$ = this.store.pipe(select(sitesStateIsLoading));
    this.loadedSite$ = this.store.pipe(select(siteLoadedState));
    this.created$ = this.store.pipe(select(sitesStateCreated));
    this.profileList$ = this.store.pipe(select(siteProfileLoadedState));
    this.regionList$ = this.store.pipe(select(siteRegionLoadedState));
    this.categoryList$ = this.store.pipe(select(loadedCategoriesListSiteState));
    this.propertyList$ = this.store.pipe(select(loadedPropertiesListSiteState));
    this.currentTenant$ = this.store.pipe(select(loadedTenantConfigState));

    //initialize card configuration
    this.card = {
      avatarUrl: "",
      content: "",
      imageUrl: "",
      current: "",
      title: "SiteManagement.newSite",
      subtitle: this.duplication
        ? "SiteManagement.duplication"
        : "SiteManagement.creation",
    };
  }

  siteTabChanged(event: MatTabChangeEvent) {
    const { index } = event;
    this.showTopcardUpdate = index === 0;
  }

  confirmDialog(dialog: any, refresh = false): Observable<boolean> {
    const dialogData: Dialog = GuardConfirmationDialogData;
    const dialogRef = dialog.open(ConfirmationDialogComponent, dialogData);
    if (!refresh) {
      return dialogRef.afterClosed();
    }
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.reload();
      }
    });
  }

  openAddLedSiteConfirmationDialog() {
    const dialogData: Dialog = AddSiteLedSiteConfirmationDialogData;
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, { ...dialogData, disableClose: true });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (!confirmed) {
        this.ledSiteSubscription.unsubscribe();
        this.siteDataForm.get(FORM_PARAMS.ledSite).setValue(false);
        this.onLedSiteChanges(this.siteDataForm);
      }
    });
  }

  openRemoveLedSiteConfirmationDialog() {
    const dialogData: Dialog = RemoveSiteLedSiteConfirmationDialogData2;
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, { ...dialogData, disableClose: true });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (!confirmed) {
        this.ledSiteSubscription.unsubscribe();
        this.siteDataForm.get(FORM_PARAMS.ledSite).setValue(true);
        this.onLedSiteChanges(this.siteDataForm);
      }
    });
  }

  ngOnInit(): void {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = "ignore";

    this.route.params.subscribe((params) => {
      const code = params.id;
      this.creation = false;
      this.duplication = false;
      const duplicateCode = localStorage.getItem("duplicate");

      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      if (code && code.length) {
        this.initialiseState(code, false);
      } else if (duplicateCode !== null) {
        this.duplication = true;
        localStorage.removeItem("duplicate");
        this.initialiseState(duplicateCode, true);
      } else {
        this.creation = true;
        this.initialiseState("", false);
      }
    });

    //Initialize FormGroup
    this.createSiteForm();
    this.loadSiteInfo();
    this.loadLangChanges();
    this.resetCreation();
  }

  ngAfterViewInit(): void {
    if (this.creation) {
      setTimeout(() => {
        this.initMap();
      });
    }
  }

  initMap(latitude?: number, longitude?: number): void {
    if (this.map) {
      this.map.remove();
    }
    
    this.setMapMarker();

    if (!latitude || !longitude) {
      this.setDefaultMap();
      this.setMapClickEvent();
      this.addSearchControl();
      this.setSearchEvent();
      return;
    }
    
    this.map = L.map('map', {
      center: [latitude, longitude],
      zoom: 13,
    });

    const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      center: [latitude, longitude],
      zoom: 13,
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    });
    tiles.addTo(this.map);

    if (latitude || longitude) {
      this.marker = L.marker([latitude, longitude], { draggable: true }).addTo(this.map);
    };
    
    this.setMarkerDragEvent();
    this.setMapClickEvent();  
    this.addSearchControl();
    this.setSearchEvent();
  }

  setMapMarker() {
    const iconRetinaUrl = 'assets/marker-icon-2x.png';
    const iconUrl = 'assets/marker-icon.png';
    const shadowUrl = 'assets/marker-shadow.png';
    const iconDefault = icon({
      iconRetinaUrl,
      iconUrl,
      shadowUrl,
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      tooltipAnchor: [16, -28],
      shadowSize: [41, 41]
    });
    Marker.prototype.options.icon = iconDefault;
  }

  setDefaultMap() {
    this.map = L.map('map', {
      center: [DEFAULT_LAT, DEFAULT_LNG],
      zoom: 4,
    });

    const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      center: [DEFAULT_LAT, DEFAULT_LNG],
      zoom: 4,
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    });
    tiles.addTo(this.map);
  }

  setMarkerDragEvent() {
    this.marker.on('dragend', (ev: any) => {
      if (ev.target && ev.target.getLatLng()) {
        const latitude = ev.target.getLatLng().lat;
        const longitude = ev.target.getLatLng().lng;
        this.setFormLatLng(latitude, longitude);
        this.reverseOpenStreetMap(latitude, longitude);
      }
    });
  }

  setMapClickEvent() {
    this.map.on('click', (ev: any) => {
      if (ev.latlng && ev.latlng.lat && ev.latlng.lng) {
        const latitude = ev.latlng.lat;
        const longitude = ev.latlng.lng;
        if (this.marker) {
          this.marker.setLatLng([latitude, longitude]);
        } else {
          this.marker = L.marker([latitude, longitude], { draggable: true }).addTo(this.map);
          this.setMarkerDragEvent();
        }
        this.setFormLatLng(latitude, longitude);
        this.reverseOpenStreetMap(latitude, longitude);
      }
    });
  }

  addSearchControl() {
    const searchControl = SearchControl({
      provider: new OpenStreetMapProvider(),
      style: 'button',
      showMarker: false,
      autoClose: true,
      searchLabel: this.translate.instant("SiteManagement.searchAddress"),
    });
    this.map.addControl(searchControl);
  }

  setSearchEvent() {
    this.map.on('geosearch/showlocation', (ev) => {
      const latitude = ev.marker.getLatLng().lat;
      const longitude = ev.marker.getLatLng().lng;
      if (this.marker) {
        this.marker.setLatLng([latitude, longitude]);
      } else {
        this.marker = L.marker([latitude, longitude], { draggable: true }).addTo(this.map);
        this.setMarkerDragEvent();
      }
      this.setFormLatLng(latitude, longitude);
    });
  }
  
  setFormLatLng(latitude: number, longitude: number) {
    this.emitEvent = false;
    this.siteDataForm.get(FORM_PARAMS.latitude).setValue(latitude);
    this.siteDataForm.get(FORM_PARAMS.longitude).setValue(longitude);
    this.siteDataForm.markAsDirty();
    this.emitEvent = true;
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  resetCreation() {
    this.createdSub = this.created$.pipe(skip(1)).subscribe((created) => {
      if (created) {
        this.creation = false;
        this.duplication = false;
      }
    });
  }

  createSiteForm() {
    this.siteDataForm = this.fb.group({
      [FORM_PARAMS.siteNumber]: [
        null,
        [Validators.required, FormUtils.noWhitespaceValidator],
      ],
      [FORM_PARAMS.description]: [
        null,
        [Validators.required, FormUtils.noWhitespaceValidator, Validators.maxLength(100)],
      ],
      [FORM_PARAMS.profile]: [null, Validators.required],
      [FORM_PARAMS.tenant]: [
        { value: null, disabled: true },
        [Validators.required, FormUtils.isObjectValidator],
      ],
      [FORM_PARAMS.entity]: [
        { value: null, disabled: true },
        [Validators.required, FormUtils.isObjectValidator],
      ],
      [FORM_PARAMS.region]: [null, Validators.required],
      [FORM_PARAMS.siteGroup]: [null, FormUtils.isObjectValidator],
      [FORM_PARAMS.latitude]: [{ value: null, disabled: true }, Validators.maxLength(45)],
      [FORM_PARAMS.longitude]: [{ value: null, disabled: true }, Validators.maxLength(45)],
      [FORM_PARAMS.enabled]: [true],
      [FORM_PARAMS.ledSite]: [false],
      [FORM_PARAMS.vatin]: [null, [Validators.required, Validators.minLength(2), Validators.maxLength(20)]],
      [FORM_PARAMS.categories]: this.fb.array([]),
      [FORM_PARAMS.properties]: this.fb.array([]),
      [FORM_PARAMS.comment]: [null],
      [FORM_PARAMS.street]: [null, Validators.maxLength(100)],
      [FORM_PARAMS.postalZipCode]: [null, Validators.maxLength(10)],
      [FORM_PARAMS.city]: [null, Validators.maxLength(30)],
      [FORM_PARAMS.phone]: [null],
    });
    if (this.creation) {
      this.onLedSiteChanges(this.siteDataForm);
    }
    this.onTenantChanges(this.siteDataForm);
    this.validateDisabledTenant(this.siteDataForm);
  }

  validateDisabledTenant(form: FormGroup): void {
      this.currentTenant$.subscribe((tenant) => {
        form.get(FORM_PARAMS.tenant).setValue(tenant);
      });
    if (this.currentUserProfile === UserProfileCodes.ENTITY_ADMINISTRATOR) {
      const currentEntity = {
        entity: localStorage.getItem("entity"),
        entityToken: localStorage.getItem("entityToken"),
      };
      form.get(FORM_PARAMS.entity).setValue({ 
        token: currentEntity?.entityToken,
        description: currentEntity?.entity,
      });
      form.get(FORM_PARAMS.entity).disable();
    }
  }

  onLedSiteChanges(form: FormGroup): void {
    this.ledSiteSubscription = form.get(FORM_PARAMS.ledSite).valueChanges.subscribe((ledSite) => {
      if (ledSite) {
        this.openAddLedSiteConfirmationDialog();
      } else {
        this.openRemoveLedSiteConfirmationDialog();
      }
    });
  }

  onTenantChanges(form: FormGroup): void {
    form.get(FORM_PARAMS.tenant).valueChanges.subscribe((tenant) => {
      if (tenant && this.currentUserProfile !== UserProfileCodes.ENTITY_ADMINISTRATOR) {
        form.get(FORM_PARAMS.entity).enable();
      } else {
        form.get(FORM_PARAMS.entity).setValue(null);
        form.get(FORM_PARAMS.entity).disable();
      }
    });
  }

  loadLangChanges() {
    this.langSubscription = this.translate.onLangChange.subscribe(() => {
      this.titleService.setTitle(
        this.translate.instant("SiteManagement.Details")
      );
    });
  }

  onLatitudeChanges(form: FormGroup): void {
    form.get(FORM_PARAMS.latitude).valueChanges.subscribe((latitude) => {
      if (this.emitEvent) {
        const longitude = form.get(FORM_PARAMS.longitude).value;
        if (Number(latitude)) {
          this.initMap(latitude, longitude);
          return;
        }
        this.initMap();
      }
    });
  }

  onLongitudeChanges(form: FormGroup): void {
    form.get(FORM_PARAMS.longitude).valueChanges.subscribe((longitude) => {
      if (this.emitEvent) {
        const latitude = form.get(FORM_PARAMS.latitude).value;
        if (Number(longitude)) {
          this.initMap(latitude, longitude);
          return;
        } 
        this.initMap();
      }
    });
  }

  onAddressChanges(form: FormGroup): void {
    this.streetSubscription = form.get(FORM_PARAMS.street).valueChanges.subscribe(() => {
      clearTimeout(this.changesTimer);
      this.changesTimer = window.setTimeout(() => {
        this.searchOpenStreetMap(form);
      }, 1000);
    });
    this.postalZipCodeSubscription = form.get(FORM_PARAMS.postalZipCode).valueChanges.subscribe(() => {
      clearTimeout(this.changesTimer);
      this.changesTimer = window.setTimeout(() => {
        this.searchOpenStreetMap(form);
      }, 1000);
    });
    this.citySubscription = form.get(FORM_PARAMS.city).valueChanges.subscribe(() => {
      clearTimeout(this.changesTimer);
      this.changesTimer = window.setTimeout(() => {
        this.searchOpenStreetMap(form);
      }, 1000);
    });
  }

  searchOpenStreetMap(form: FormGroup) {
    const street = form.get(FORM_PARAMS.street).value;
    const postalZipCode = form.get(FORM_PARAMS.postalZipCode).value;
    const city = form.get(FORM_PARAMS.city).value;
    this.sitesService.searchOpenStreetMap(street, postalZipCode, city)
    .pipe(
      catchError((error) => {
        return EMPTY;
      }),
    ).subscribe((result) => {
      const [first] = result;
      const { lat, lon } = first;
      this.initMap(lat, lon);
      this.setFormLatLng(lat, lon);
    });
  }

  reverseOpenStreetMap(latitude: string, longitude: string) {
    this.unsubscribeAddressFormFields();
    this.sitesService.reverseOpenStreetMap(latitude, longitude)
    .pipe(
      catchError((error) => {
        return EMPTY;
      }),
    ).subscribe((result) => {
      const { address: { road, postcode, city }} = result;

      this.siteDataForm.get(FORM_PARAMS.street).setValue(road);
      this.siteDataForm.get(FORM_PARAMS.postalZipCode).setValue(postcode);
      this.siteDataForm.get(FORM_PARAMS.city).setValue(city);
      this.onAddressChanges(this.siteDataForm);
    });
  }

  unsubscribeAddressFormFields() {
    this.streetSubscription.unsubscribe();
    this.postalZipCodeSubscription.unsubscribe();
    this.citySubscription.unsubscribe();
  }

  onFccDevicesSelectionChange(event: MatSelectionListChange) {
    const [option] = event.options;
    const {
      value: { description },
    } = option;

    this.siteFccDevicesTabs = this.setOptionSelection(this.siteFccDevicesTabs, description);
  }

  onPosDevicesSelectionChange(event: MatSelectionListChange) {
    const [option] = event.options;
    const {
      value: { description },
    } = option;

    this.sitePosDevicesTabs = this.setOptionSelection(
      this.sitePosDevicesTabs,
      description
    );
  }

  onStoreDevicesSelectionChange(event: MatSelectionListChange) {
    const [option] = event.options;
    const {
      value: { description },
    } = option;

    this.siteStoreDevicesTabs = this.setOptionSelection(
      this.siteStoreDevicesTabs,
      description
    );
  }

  onWarehouseSelectionChange(event: MatSelectionListChange) {
    const [option] = event.options;
    const {
      value: { description },
    } = option;

    this.warehousesTabs = this.setOptionSelection(
      this.warehousesTabs,
      description
    );
  }

  setOptionSelection(
    optionTabs: { description: string; icon: string; selected: boolean }[],
    description: string
  ) {
    return optionTabs.reduce((acc, cur) => {
      if (cur.description === description) {
        return [...acc, { ...cur, selected: true }];
      }
      return [...acc, { ...cur, selected: false }];
    }, []);
  }

  loadSiteInfo() {
    this.multiSubs = zip(
      this.profileList$.pipe(skip(1)),
      this.regionList$.pipe(skip(1)),
      this.categoryList$.pipe(skip(1)),
      this.propertyList$.pipe(skip(1)),
    ).subscribe(([profiles, regions, categories, properties]) => {
      if (profiles && profiles.length) {
        this.profileList = profiles.map((profile) => {
          return {
            code: profile?.code,
            description: profile?.description,
          };
        });
      }

      if (regions && regions.length) {
        this.regionList = regions.map((region) => {
          return {
            code: region?.code,
            description: region?.description,
          };
        });
      }

      this.loadedSiteSubs = this.loadedSite$.subscribe((site: SiteDTO) => {
        if (site) {
          this.currentSite = cloneDeep(site);

          if (
            (!this.currCode ||
              (this.currCode && this.currCode?.length === 0)) &&
            !this.duplication
          ) {
            this.currCode = this.currentSite.code;
          }

          this.card = {
            avatarUrl: "",
            content: "",
            imageUrl: "",
            current: !this.duplication ? site?.siteNumber : "",
            title: !this.duplication
              ? "[" +
                site.siteNumber +
                "] - " +
                (site?.code?.length > 0 ? site?.description : "")
              : "SiteManagement.newSite",
            subtitle: !this.duplication
              ? "SiteManagement.site"
              : "SiteManagement.duplication",
          };

          if (this.currentSite.entityToken) {
            this.getEntity();
          }

          if (this.ledSiteSubscription) {
            this.ledSiteSubscription.unsubscribe();
          }

          this.siteDataForm.controls.siteNumber.setValue(
            this.duplication ? "" : site?.siteNumber ?? ""
          );
          this.siteDataForm.controls.description.setValue(
            site?.description ?? ""
          );
          this.siteDataForm.controls.latitude.setValue(site?.latitude ?? "");
          this.siteDataForm.controls.longitude.setValue(site?.longitude ?? "");
          this.siteDataForm.controls.enabled.setValue(site?.enabled ?? false);
          this.siteDataForm.controls.ledSite.setValue(site?.ledSite ?? false);
          this.siteDataForm.controls.street.setValue(site?.street ?? "");
          this.siteDataForm.controls.postalZipCode.setValue(site?.postalZipCode ?? "");
          this.siteDataForm.controls.city.setValue(site?.city ?? "");
          this.siteDataForm.controls.phone.setValue(site?.phone ?? "");
          this.siteDataForm.controls.profile.setValue(site?.siteProfile?.code ?? "");
          this.siteDataForm.controls.region.setValue(site?.region?.code ?? "");
          this.siteDataForm.controls.siteGroup.setValue(
            site?.siteGroup 
              ? { 
                code: site.siteGroup.code,
                displayCode: site.siteGroup.code,
                description: site.siteGroup.description,
              } 
              : ""
          );
          this.siteDataForm.controls.vatin.setValue(site?.vatin ?? null);
          this.siteDataForm.controls.comment.setValue(site?.comment ?? "");

          this.initMap(this.siteDataForm.get(FORM_PARAMS.latitude).value, this.siteDataForm.get(FORM_PARAMS.longitude).value);
          this.onLedSiteChanges(this.siteDataForm);
          this.onAddressChanges(this.siteDataForm);
        }

        // Set Categories and Properties
        if (site || this.creation || this.duplication) {
          if (categories && categories.length) {
            this.categoryList = categories;
          }
          if (properties && properties.length) {
            this.propertyList = properties;
          }
        }
      });
    });

    this.store.dispatch(getSiteProfileList(null));
    this.store.dispatch(getSiteRegionsList(null));
    this.store.dispatch(
      getCategoriesForListByUsage({
        pageReq: {
          query: "is_enabled==1",
          limit: undefined,
          offset: 0,
          realSize: true,
        },
        usageCode: USAGE_CODE,
      })
    );
    this.store.dispatch(
      getPropertiesForListByUsage({
        pageReq: {
          query: "is_enabled==1",
          limit: undefined,
          offset: 0,
          realSize: true,
        },
        usageCode: USAGE_CODE,
      })
    );
  }

  getEntity() {
    this.isLoadingTenantEntity$.next(true);
    this.entityService
      .getEntity(this.currentSite.entityToken)
      .pipe(
        catchError((error) => {
          this.snackbarService.show({
            message: this.translate.instant("Entity.entityLoadError"),
            type: SnackbarType.ERROR,
          });
          return EMPTY;
        }),
        finalize(() => this.isLoadingTenantEntity$.next(false))
      )
      .subscribe((entity) => {
        this.siteDataForm.controls.tenant.setValue(
          entity && entity.tenant
          ? { 
              token: entity.tenant.token,
              description: entity.tenant.description,
            }
          : null
        );
        this.siteDataForm.controls.entity.setValue(
          entity
          ? { 
              token: entity.token,
              description: entity.description,
            }
          : null
        );
      });
  }

  initialiseState(code: string, duplicate?: boolean) {
    if (code && code.length) {
      this.loadSite(code);
      if (duplicate) {
        this.currCode = "";
      } else {
        this.currCode = code;
      }
    } else {
      this.reset();
      this.currCode = "";
      this.card = {
        avatarUrl: "",
        content: "",
        imageUrl: "",
        current: "",
        title: "SiteManagement.newSite",
        subtitle: this.duplication
          ? "SiteManagement.duplication"
          : "SiteManagement.creation",
      };
    }
  }

  loadSite(code: string) {
    if (code && code.length) {
      this.store.dispatch(getSite({ code: code }));
    }
  }

  reset() {
    this.store.dispatch(resetSite());
  }

  back() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.location.back();
  }

  validateFirstTenantSearch() {
      this.searchTenants('');
  }

  searchTenants(event: KeyboardEvent | string, hasTimer = true): void {
    const searchTerm = typeof event === 'string' ? event : (event.target as HTMLInputElement).value;

    clearTimeout(this.searchTimer);
    this.searchTimer = window.setTimeout(
      () => {
        this.isLoadingTenant$.next(true);
        this.tenantsList$ = this.tenantService
          .getTenantsList(null, {
            filterConfig: [{ field: "description" }],
            searchTerms: [searchTerm],
          })
          .pipe(
            map(({ items }) => items),
            catchError((error) => {
              this.snackbarService.show({
                message: this.translate.instant("Tenant.tenantsLoadError"),
                type: SnackbarType.WARNING,
              });
              return EMPTY;
            }),
            finalize(() => this.isLoadingTenant$.next(false)),
            shareReplay()
          );
      },
      hasTimer ? 500 : 0
    );
  }

  displayAutocompleteOption(tenant: TenantDTO): string {
    return tenant?.description ?? "";
  }

  openTenant() {
    const tenantToken =
      this.siteDataForm.controls[FORM_PARAMS.tenant]?.value.token;
    if (tenantToken) {
      return ["/tenants/tenant", tenantToken];
    }
  }

  validateFirstEntitySearch() {
      this.searchEntities('');
  }

  searchEntities(event: KeyboardEvent | string, hasTimer = true): void {
    const searchTerm = typeof event === 'string' ? event : (event.target as HTMLInputElement).value;

    clearTimeout(this.searchTimer2);
    this.searchTimer2 = window.setTimeout(
      () => {
        this.isLoadingEntity$.next(true);
        this.entitiesList$ = this.entityService
          .getEntityList(
            null,
            {
              filterConfig: [{ field: "description" }],
              searchTerms: [searchTerm],
            },
            null,
            {
              advancedFilter: [
                {
                  column: "tenant.token",
                  operator: FilterName.EQUALS_TO,
                  value: this.siteDataForm.get(FORM_PARAMS.tenant).value.token,
                },
              ],
            }
          )
          .pipe(
            map(({ items }) => items),
            catchError((error) => {
              this.snackbarService.show({
                message: this.translate.instant("Entity.entitiesLoadError"),
                type: SnackbarType.WARNING,
              });
              return EMPTY;
            }),
            finalize(() => this.isLoadingEntity$.next(false)),
            shareReplay()
          );
      },
      hasTimer ? 500 : 0
    );
  }

  displayAutocompleteOption2(entity: EntityDTO): string {
    return entity?.description ?? "";
  }

  openEntity() {
    const entityToken =
      this.siteDataForm.controls[FORM_PARAMS.entity]?.value?.token;
    if (entityToken) {
      return ["/entities/entity", entityToken];
    }
  }

  validateFirstSiteGroupSearch() {
      this.searchSiteGroups('');
  }

  searchSiteGroups(event: KeyboardEvent | string, hasTimer = true): void {
    const searchTerm = typeof event === 'string' ? event : (event.target as HTMLInputElement).value;

    clearTimeout(this.searchTimer);
    this.searchTimer = window.setTimeout(
      () => {
        this.isLoadingSiteGroup$.next(true);
        this.siteGroupsService.getSiteGroupsList(
          undefined,
          {
            filterConfig: [{ field: "description" }],
            searchTerms: [searchTerm],
          }
        ).pipe(
          take(1),
          tap((result) => {
            const { items } = result;
            this.siteGroupsList = items.map((siteGroup: SiteGroupDTO) => {
              const { code, description } = siteGroup;
              return {
                code,
                displayCode: code ?? "",
                description,
              };
            });
          }),
          catchError((error) => {
            this.store.dispatch(
              setSnackbar(
                SnackBarUtils.setSnackBar(
                  this.translate.instant("SiteGroup.siteGroupsLoadError"),
                  SnackbarType.ERROR
                )
              )
            );
            return EMPTY;
          }),
          finalize(() => this.isLoadingSiteGroup$.next(false))
        ).subscribe();
      },
      hasTimer ? 500 : 0
    );
  }

  displayAutocompleteOption3(siteGroup: SiteGroupDTO): string {
    return siteGroup?.description ?? "";
  }

  openSiteGroup() {
    const siteGroupCode = this.siteDataForm.controls[FORM_PARAMS.siteGroup]?.value?.code;
    if (siteGroupCode) {
      return ["/site-groups/site-group", siteGroupCode];
    }
  }

  onSubmit() {
    if (!this.siteDataForm.valid) {
      this.siteDataForm.markAllAsTouched();
      this.snackbarService.show({
        message: this.translate.instant("SiteManagement.SiteFormInvalid"),
        type: SnackbarType.ERROR,
      });
      return;
    }
    
    if (this.siteDataForm.pristine && !this.creation && !this.duplication) {
      this.snackbarService.show({
        message: this.translate.instant("SiteManagement.NoChanges"),
        type: SnackbarType.WARNING,
      });
      return;
    }

    let site: SiteDTO = {
      siteNumber: this.siteDataForm.controls.siteNumber.value ?? "",
      description: this.siteDataForm.controls.description.value ?? "",
      siteProfileCode: this.siteDataForm.controls.profile.value ?? "",
      tenantToken: this.siteDataForm.controls.tenant.value
        ? this.siteDataForm.controls.tenant.value.token
        : null,
      entityToken: this.siteDataForm.controls.entity.value
        ? this.siteDataForm.controls.entity.value.token
        : null,
      regionCode: this.siteDataForm.controls.region.value ?? "",
      siteGroupCode: this.siteDataForm.controls.siteGroup.value 
        ? this.siteDataForm.controls.siteGroup.value.code
        : null,
      latitude: this.siteDataForm.controls.latitude.value ?? "",
      longitude: this.siteDataForm.controls.longitude.value ?? "",
      enabled: this.siteDataForm.controls.enabled.value ?? false,
      ledSite: this.siteDataForm.controls.ledSite.value ?? false,
      vatin: this.siteDataForm.controls.vatin.value ?? null,
      categories: CategoriesAndPropsUtils.setFormCategories(
        this.siteDataForm.controls.categories.value
      ),
      properties: CategoriesAndPropsUtils.setFormProperties(
        this.siteDataForm.controls.properties.value
      ),
      comment: this.siteDataForm.controls.comment.value ?? "",
      street: this.siteDataForm.controls.street.value ?? "",
      postalZipCode: this.siteDataForm.controls.postalZipCode.value ?? "",
      city: this.siteDataForm.controls.city.value ?? "",
      phone: this.siteDataForm.controls.phone.value ?? "",
    };

    if (this.currCode.length === 0) {
      this.store.dispatch(createSite({ site }));
    } else {
      site = { ...site, code: this.currCode };
      this.store.dispatch(updateSite({ site }));
    }

    this.siteDataForm.markAsUntouched();
    this.siteDataForm.markAsPristine();
  }

  refresh() {
    if (isAuthenticated(this.router.url) && !this.siteDataForm.pristine) {
      this.confirmDialog(this.dialog, true);
      return;
    } else {
      this.reload();
    }
  }
  
  reload() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = "reload";
    this.router.navigate(["sites/site", this.currCode]);
  }

  createNew() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = "reload";
    this.router.navigate(["/sites/site"]);
    this.creation = true;
  }

  duplicate() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    localStorage.setItem("duplicate", this.currCode);
    this.router.onSameUrlNavigation = "reload";
    this.router.navigate(["sites/site", {}]);
  }

  identify(index, item) {
    return item.code;
  }

  ngOnDestroy(): void {
    if (this.createdSub) {
      this.createdSub.unsubscribe();
    }
    if (this.multiSubs) {
      this.multiSubs.unsubscribe();
    }
    if (this.loadedSiteSubs) {
      this.loadedSiteSubs.unsubscribe();
    }
    if (this.langSubscription) {
      this.langSubscription.unsubscribe();
    }
    if (this.ledSiteSubscription) {
      this.ledSiteSubscription.unsubscribe();
    }
    if (this.streetSubscription) {
      this.streetSubscription.unsubscribe();
    }
    if (this.postalZipCodeSubscription) {
      this.postalZipCodeSubscription.unsubscribe();
    }
    if (this.citySubscription) {
      this.citySubscription.unsubscribe();
    }
  }

  @HostListener("window:beforeunload")
  canDeactivate(): Observable<boolean> | boolean {
    return this.isNavigationAllowed();
  }

  isNavigationAllowed(): Observable<boolean> | boolean {
    if (
      !isAuthenticated(this.router.url) || 
      (this.siteDataForm.pristine &&
      this.isWarehousePristine &&
      this.isDispenserPristine &&
      this.isFccPristine &&
      this.isPosPristine &&
      this.isFuelPointPristine &&
      this.isTankGaugePristine &&
      this.isPriceSignPristine &&
      this.isProductsPristine &&
      this.isGradesPristine)
    ) {
      return true;
    } else {
      return false;
    }
  }

  getWarehouse(form: FormGroup) {
    this.isWarehousePristine = form?.pristine;
  }
  getDispenser(form: FormGroup) {
    this.isDispenserPristine = form?.pristine;
  }
  getFcc(form: FormGroup) {
    this.isFccPristine = form?.pristine;
  }
  getPos(form: FormGroup) {
    this.isPosPristine = form?.pristine;
  }
  getFuelPoint(form: FormGroup) {
    this.isFuelPointPristine = form?.pristine;
  }
  getPriceSign(form: FormGroup) {
    this.isPriceSignPristine = form?.pristine;
  }
  getTankGauge(form: FormGroup) {
    this.isTankGaugePristine = form?.pristine;
  }
  getProductsForm(form: FormGroup) {
    this.isProductsPristine = form?.pristine;
  }
  getGradesForm(form: FormGroup) {
    this.isGradesPristine = form?.pristine;
  }
  getPeripheral(form: FormGroup) {
    this.isPeripheralPristine = form?.pristine;
  }
  getMultimedia(form: FormGroup) {
    this.isMultimediaPristine = form?.pristine;
  }
}
